import { useEffect, useState } from 'react';

// True once the window has scrolled past `threshold` pixels. Drives the header backdrop.
const useScrolled = (threshold = 0) => {
    const [scrolled, setScrolled] = useState(() => window.scrollY > threshold);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > threshold);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold]);

    return scrolled;
};

export default useScrolled;
